let active = [];

class TextCycle {
  constructor ($el) {
    this.$el = $el;
    this.words = this.$el.dataset.words.split(',');
    this.speed = this.$el.dataset.speed;
    this.index = 0;
    this.cycle();
  };

  cycle () {
    this.$el.innerText = this.words[this.index];
    this.index++;
    if (this.index > this.words.length - 1)
      this.index = 0;

    this.timer = setTimeout(() => this.cycle(), this.speed);
  };

  stop () {
    clearTimeout(this.timer);
  };

  // Stops the previous page's cycles before starting the current page's, so a
  // Turbo navigation does not leave timers firing on detached nodes.
  static ready () {
    active.forEach(instance => instance.stop());

    active = [...document.querySelectorAll('.js-text-cycle')].map($el => new TextCycle($el));
  }
};

export default TextCycle;
